import { createSlice } from '@reduxjs/toolkit'

export const proDashboardSlice = createSlice({
  name: 'proDashboard',
  initialState: {
    selectedProfile: '',
    profileOptions: [
      {
        label: 'Pro Dashboard',
        value: 'dashboard-1',
      },
      // {
      //   label: 'Dashboard Standard',
      //   value: 'dashboard-2',
      // },
      {
        label: 'Leads Dashboard',
        value: 'dashboard-leads',
      },
      {
        label: 'Starter Dashboard',
        value: 'dashboard-pro',
      },
    ],
  },
  reducers: {
    setSelectedDashboard: (state, action) => {
      state.selectedProfile = action.payload
    },
  },
})

export const selectedProfile = (state: any) => state.proDashboard.selectedProfile
export const profileOptions = (state: any) => state.proDashboard.profileOptions

export const { setSelectedDashboard } = proDashboardSlice.actions

export default proDashboardSlice.reducer
